/*
EXAMPLE
{createImageUrl({url: logo, options: ['w_250', 'dpr_2.0']})}
*/

export default ({
  url,
  options = [],
}) => url.replace('upload/', `upload/${options.join(',')}/`);
